export default "__VITE_ASSET__$N9UQmxK__"